import { IAction } from '@/redux/actions/action-helpers'
import { ExpensePolicyTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

function expensePolicy(state: ApplicationState['expensePolicy'] = {}, action: IAction) {
	switch (action.type) {
		case ExpensePolicyTypes.GetPolicy.SUCCESS:
			return action.payload
		case ExpensePolicyTypes.UpdateApproversPolicy.SUCCESS:
			return action.payload
		default:
			return state
	}
}

export default expensePolicy
